"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _components = require("@react-email/components");
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _nocodbsdk = require("nocodb-sdk");
const _components1 = require("~/services/mail/templates/components");
const _constants = require("~/constants");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormSubmission = ({ formTitle, baseTitle, tableTitle, submissionData })=>/*#__PURE__*/ _react.createElement(_components.Html, null, /*#__PURE__*/ _react.createElement(_components1.RootWrapper, null, /*#__PURE__*/ _react.createElement(_components.Head, null), /*#__PURE__*/ _react.createElement(_components.Preview, null, "You have a new response!"), /*#__PURE__*/ _react.createElement(_components.Body, {
        className: "bg-white"
    }, /*#__PURE__*/ _react.createElement(_components1.ContentWrapper, {
        disableContainerPadding: true
    }, /*#__PURE__*/ _react.createElement(_components.Section, {
        className: "p-6 mx-auto"
    }, /*#__PURE__*/ _react.createElement(_components.Heading, {
        className: "text-gray-900 text-center font-bold m-auto text-xl md:text-2xl"
    }, "You have a new response!"), /*#__PURE__*/ _react.createElement(_components.Section, {
        align: "center",
        className: "my-6",
        style: {
            textAlign: 'center',
            lineHeight: '28px'
        }
    }, /*#__PURE__*/ _react.createElement("table", {
        cellPadding: "0",
        cellSpacing: "0",
        style: {
            display: 'inline-block',
            verticalAlign: 'middle'
        }
    }, /*#__PURE__*/ _react.createElement("tr", null, /*#__PURE__*/ _react.createElement("td", {
        style: {
            paddingRight: '8px',
            verticalAlign: 'middle'
        }
    }, /*#__PURE__*/ _react.createElement(_components.Img, {
        src: `${_constants.NC_EMAIL_ASSETS_BASE_URL}/icons/form-view.png`,
        alt: "Form View Icon",
        height: 24,
        width: 24,
        className: "!h-6 inline-block",
        style: {
            verticalAlign: 'middle'
        }
    })), /*#__PURE__*/ _react.createElement("td", {
        style: {
            verticalAlign: 'middle'
        }
    }, /*#__PURE__*/ _react.createElement("span", {
        className: "text-base font-bold mt-0.5 text-gray-900",
        style: {
            verticalAlign: 'middle',
            display: 'inline-block',
            lineHeight: '28px'
        }
    }, formTitle))))), /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-center font-weight-thin text-gray-600 !my-0"
    }, "Someone has responded to your form, a record has been added to", /*#__PURE__*/ _react.createElement("span", {
        className: "font-bold text-gray-800"
    }, " ", tableTitle, " "), "in", /*#__PURE__*/ _react.createElement("span", {
        className: "font-bold text-gray-800"
    }, " ", baseTitle), ".")), /*#__PURE__*/ _react.createElement(_components.Hr, null), /*#__PURE__*/ _react.createElement(_components.Section, {
        className: "p-6 mx-auto"
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-lg font-bold text-center !my-0"
    }, "Here is a copy of the response"), /*#__PURE__*/ _react.createElement(_components.Section, null, submissionData.map((s)=>/*#__PURE__*/ _react.createElement(_components.Section, {
            className: "mt-6",
            key: s.columnTitle
        }, /*#__PURE__*/ _react.createElement(_components.Row, null, /*#__PURE__*/ _react.createElement(_components.Column, {
            className: "flex align-middle items-center"
        }, /*#__PURE__*/ _react.createElement(_components.Img, {
            className: "align-middle",
            width: 16,
            height: 16,
            src: (0, _components1.getFieldIconUrl)(s.uidt)
        }), /*#__PURE__*/ _react.createElement(_components.Section, {
            className: "!ml-2 inline-block text-[13px] !my-0 !mr-0 leading-4.5 text-gray-600 align-middle max-w-xs whitespace-pre-wrap"
        }, s.columnTitle))), /*#__PURE__*/ _react.createElement(_components.Row, {
            className: "px-4 py-2 border border-1 mt-2 border-solid rounded-lg border-gray-200",
            style: {
                boxShadow: `0px 0px 4px 0px rgba(0, 0, 0, 0.08)`
            }
        }, /*#__PURE__*/ _react.createElement(_components.Column, null, /*#__PURE__*/ _react.createElement(_components.Text, {
            className: "text-gray-800 !my-0 max-w-xs whitespace-pre-wrap"
        }, s.parsedValue)))))))), /*#__PURE__*/ _react.createElement(_components1.Footer, null))));
FormSubmission.PreviewProps = {
    formTitle: 'Form Name',
    tableTitle: 'Table Name',
    baseTitle: 'Base Name',
    submissionData: [
        {
            parsedValue: '$344',
            uidt: _nocodbsdk.UITypes.Currency,
            columnTitle: 'Currency'
        },
        {
            parsedValue: 'Checked',
            uidt: _nocodbsdk.UITypes.Checkbox,
            columnTitle: 'Checkbox'
        }
    ]
};
const _default = FormSubmission;
